import { useQuery } from '@tanstack/react-query';
import { fetchStudentData } from '../api/students';
import { useContext } from 'react';
import AuthContext from '../contexts/AuthContext';

const useAllStudentGoalsData = (uid, typeOfUser, options = {}) => {
  const { user } = useContext(AuthContext);
  return useQuery({
    queryKey: [
      'fetchStudentData',
      uid,
      typeOfUser,
      options.includeDataCollection ?? true,
      options.includeGoalData ?? true,
    ],
    queryFn: async () => {
      if (!uid || !typeOfUser) {
        return null;
      }

      const fetchedData = await fetchStudentData(uid, typeOfUser, options);

      if (!fetchedData && user?.isMigrated && typeOfUser === 'STUDENT') {
        const mockStudentData = {
          id: user.uid,
          name: user.fullname || user.name || 'Student',
          email: user.email,
          age: user.age || 0,
          gender: user.gender || '',
          dob: user.dob || null,
          contactNo: user.contactNo || { areaCode: '+1', number: '' },
          dataCollection: [],
          goalData: [],
        };

        return [mockStudentData];
      }

      return fetchedData || null;
    },
    // Use global QueryClient settings by default
    // Only override if specific options are provided
    ...options,
    // Ensure we don't refetch unnecessarily
    refetchOnMount: options.refetchOnMount ?? false,
    refetchOnWindowFocus: options.refetchOnWindowFocus ?? false,
    // Keep data fresh for longer to reduce API calls
    staleTime: options.staleTime ?? 5 * 60 * 1000, // 5 minutes
    gcTime: options.gcTime ?? 10 * 60 * 1000, // 10 minutes
  });
};

export default useAllStudentGoalsData;
